import React from "react";
import EditCaptionModal from "./edit-caption";

const EditorModal = ({ editor }) => {
    return <EditCaptionModal editor={editor} />;
};

export default EditorModal;
